import { render, staticRenderFns } from "./BotaoDownload.vue?vue&type=template&id=33588e58&scoped=true&"
import script from "./BotaoDownload.vue?vue&type=script&lang=js&"
export * from "./BotaoDownload.vue?vue&type=script&lang=js&"
import style0 from "./BotaoDownload.vue?vue&type=style&index=0&id=33588e58&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33588e58",
  null
  
)

export default component.exports